export default __webpack_public_path__ + "static/media/Gustixa - play date (lofi remix) LYRICS.021c60a5.mp3";